import Component from './Location.vue';

export default {
  install(Vue) {
    Vue.component('BkfIconLocation', Component);
  },
};
